import { track as customTrack } from '@amplitude/analytics-browser';
import Cookies from 'js-cookie';
import { hasStatisticsConsent } from 'utils/helpers/cookiebot';

/*
Every Amplitude event in the app goes through here, so this is the guard that
actually holds: a missing, declined or revoked statistics consent stops all of
utils/helpers/amplitude.ts, even where a component tracks before App has
re-synced with Cookiebot.
*/
const track = (eventName: string, eventData: object) => {
  if (!hasStatisticsConsent()) {
    return false;
  }
  const isBotUser = Cookies.get('isBotUser') === 'true';
  const urlParams = new URLSearchParams(window.location.search);
  const isTrackingOff = urlParams.get('track') === 'off';
  return !isBotUser && !isTrackingOff && customTrack(eventName, eventData);
};

export default track;
